import useIndexedDbWorker from './useIndexedDbWorker'

export default useIndexedDbWorker
